var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.52 61.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e72429;\n      }\n\n      .cls-2 {\n        fill: #0b1722;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.66,29.79c0-4.36-3.25-8.03-7.57-8.56-1.45,5.61-1.45,11.5,0,17.12,4.32-.53,7.57-4.2,7.57-8.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.67,27.08c-1.5,0-2.71,1.21-2.71,2.71s1.21,2.71,2.71,2.71,2.71-1.21,2.71-2.71h0c0-1.5-1.21-2.71-2.71-2.71h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.03,29.79c0,4.36,3.25,8.03,7.57,8.56,1.45-5.61,1.45-11.5,0-17.12-4.32.53-7.57,4.21-7.57,8.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.99,27.08c-1.5,0-2.71,1.21-2.71,2.7,0,1.5,1.21,2.71,2.7,2.71,1.5,0,2.71-1.21,2.71-2.7,0,0,0,0,0,0,0-1.49-1.21-2.71-2.7-2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.78,51.05c-4.35,0-8.02,3.25-8.56,7.57,5.61,1.45,11.5,1.45,17.12,0-.53-4.32-4.21-7.57-8.56-7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.79,43.32c-1.5,0-2.71,1.21-2.71,2.7,0,1.5,1.21,2.71,2.7,2.71,1.5,0,2.71-1.21,2.71-2.7,0,0,0,0,0,0,0-1.49-1.21-2.71-2.7-2.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.79,8.65c4.35,0,8.02-3.25,8.56-7.57-5.61-1.45-11.5-1.45-17.12,0,.54,4.32,4.21,7.57,8.56,7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.79,10.97c-1.5,0-2.71,1.21-2.71,2.7,0,1.5,1.21,2.71,2.7,2.71s2.71-1.21,2.71-2.7c0,0,0,0,0,0,0-1.49-1.21-2.7-2.7-2.7h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.79,44.79c-3.07,3.08-3.37,7.97-.7,11.4,4.99-2.95,9.16-7.11,12.1-12.1-3.43-2.67-8.32-2.37-11.4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.33,39.33c-1.06,1.06-1.06,2.77,0,3.83,1.06,1.06,2.77,1.06,3.83,0,1.06-1.06,1.06-2.77,0-3.83h0c-1.06-1.05-2.77-1.05-3.83,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.83,14.83c3.08-3.08,3.38-7.96.7-11.4-4.99,2.94-9.16,7.11-12.1,12.1,3.43,2.68,8.32,2.37,11.4-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.46,16.46c-1.06,1.06-1.06,2.77,0,3.83,1.06,1.06,2.77,1.06,3.83,0,1.06-1.06,1.06-2.77,0-3.83h0c-1.06-1.05-2.77-1.05-3.83,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.77,14.8c3.08,3.07,7.97,3.37,11.4.69-2.95-4.99-7.11-9.15-12.1-12.09-2.67,3.43-2.37,8.32.7,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.14,20.26c1.06-1.06,1.05-2.77,0-3.82-1.06-1.06-2.77-1.05-3.82,0-1.05,1.06-1.05,2.77,0,3.82,1.06,1.06,2.77,1.06,3.82,0,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.81,44.76c-3.08-3.07-7.96-3.37-11.4-.7,2.94,4.99,7.11,9.16,12.1,12.1,2.67-3.43,2.37-8.32-.7-11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.43,39.3c-1.06,1.06-1.06,2.77,0,3.83,1.06,1.06,2.77,1.06,3.83,0,1.06-1.06,1.06-2.77,0-3.83h0c-1.06-1.05-2.77-1.05-3.83,0"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.1,46.78c2.25,0,3.57,1.33,3.57,3.2,0,1.27-.73,2.17-1.77,2.55,1.35.33,2.13,1.53,2.13,2.85,0,1.87-1.48,3.22-3.65,3.22h-4.14v-11.83h3.85ZM83.92,51.95c1.32,0,2.1-.78,2.1-1.88s-.82-1.85-2.17-1.85h-1.97v3.74h2.03ZM84.15,57.17c1.32,0,2.22-.73,2.22-1.89s-.72-1.93-2.15-1.93h-2.34v3.82h2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.09,61.95l2-4.24-3.45-7.14h1.8l2.5,5.54,2.4-5.54h1.68l-5.22,11.38h-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.97,58.6v-11.83h1.67v11.83h-1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.56,58.6h-1.57v-8.02h1.53v1.15c.58-1,1.53-1.38,2.47-1.38,1.92,0,2.87,1.38,2.87,3.17v5.09h-1.57v-4.82c0-1.12-.47-2.02-1.87-2.02-1.23,0-1.87.98-1.87,2.2v4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.6,56.02c.1.83.73,1.5,1.87,1.5.88,0,1.37-.5,1.37-1.07,0-.5-.37-.88-1.03-1.03l-1.37-.3c-1.25-.27-2-1.12-2-2.25,0-1.37,1.28-2.54,2.85-2.54,2.2,0,2.89,1.43,3.05,2.15l-1.38.52c-.07-.42-.4-1.33-1.67-1.33-.8,0-1.33.52-1.33,1.07,0,.48.3.83.92.97l1.3.28c1.45.32,2.22,1.2,2.22,2.38s-.95,2.49-2.94,2.49c-2.2,0-3.14-1.42-3.27-2.34l1.42-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.09,50.58h1.73v1.42h-1.73v4.17c0,.73.3,1.1,1.12,1.1.2,0,.48-.03.62-.07v1.33c-.13.05-.53.15-1.07.15-1.37,0-2.24-.83-2.24-2.29v-4.4h-1.53v-1.42h.43c.87,0,1.23-.53,1.23-1.23v-1.3h1.43v2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.64,52.16c-.23-.03-.47-.05-.68-.05-1.32,0-2.2.7-2.2,2.47v4.02h-1.57v-8.02h1.53v1.4c.58-1.23,1.58-1.53,2.4-1.53.22,0,.43.03.52.05v1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.66,58.85c-1.87,0-3-1.4-3-3.22v-5.05h1.57v4.82c0,1.1.5,2.07,1.82,2.07s1.9-.83,1.9-2.05v-4.84h1.57v6.54c0,.63.05,1.2.08,1.48h-1.5c-.03-.18-.07-.63-.07-.97-.43.83-1.43,1.22-2.37,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.63,54.58c0,1.83,1.15,2.82,2.45,2.82,1.5,0,2.05-1.02,2.24-1.65l1.38.6c-.38,1.15-1.53,2.5-3.62,2.5-2.33,0-4.05-1.83-4.05-4.27s1.75-4.25,4.04-4.25c2.13,0,3.24,1.33,3.57,2.55l-1.42.6c-.2-.78-.78-1.7-2.15-1.7-1.27,0-2.43.93-2.43,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.23,50.58h1.73v1.42h-1.73v4.17c0,.73.3,1.1,1.12,1.1.2,0,.48-.03.62-.07v1.33c-.13.05-.53.15-1.07.15-1.37,0-2.24-.83-2.24-2.29v-4.4h-1.53v-1.42h.43c.87,0,1.23-.53,1.23-1.23v-1.3h1.43v2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.25,58.85c-1.87,0-3-1.4-3-3.22v-5.05h1.57v4.82c0,1.1.5,2.07,1.82,2.07s1.9-.83,1.9-2.05v-4.84h1.57v6.54c0,.63.05,1.2.08,1.48h-1.5c-.03-.18-.07-.63-.07-.97-.43.83-1.43,1.22-2.37,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M168.61,52.16c-.23-.03-.47-.05-.68-.05-1.32,0-2.2.7-2.2,2.47v4.02h-1.57v-8.02h1.53v1.4c.58-1.23,1.58-1.53,2.4-1.53.22,0,.43.03.52.05v1.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M176.66,56.32c-.45,1.42-1.73,2.54-3.6,2.54-2.15,0-4.04-1.57-4.04-4.29,0-2.52,1.82-4.24,3.84-4.24,2.47,0,3.85,1.7,3.85,4.2,0,.2-.02.4-.03.5h-6.04c.03,1.43,1.07,2.43,2.42,2.43s1.95-.72,2.25-1.62l1.35.47ZM175.08,53.76c-.03-1.15-.78-2.05-2.2-2.05-1.32,0-2.12,1.02-2.19,2.05h4.39Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M77.59,23.1c0-11.93,8.93-19.11,18.44-19.11s14.82,5.47,16.48,11.88l-5.84,1.96c-1.08-4.44-4.49-8.01-10.64-8.01s-12.09,4.39-12.09,13.27,5.89,13.12,12.14,13.12,9.66-3.93,10.9-8.06l5.68,1.86c-1.65,6.2-7.23,12.14-16.58,12.14-9.86,0-18.49-7.13-18.49-19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.57,42.05c-7.39,0-12.14-5.84-12.14-13.38s4.8-13.17,12.03-13.17c4.44,0,6.71,2.32,7.39,4.03v-3.31h5.84v20.56c0,2.07.21,4.08.26,4.6h-5.73c-.1-.57-.26-1.91-.26-3.62-1.14,2.43-3.77,4.29-7.39,4.29ZM127.24,36.89c3.93,0,6.66-3.36,6.66-8.21s-2.69-7.95-6.66-7.95-6.82,3.1-6.82,7.95,2.63,8.21,6.82,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.37,41.38h-5.99v-25.15h5.84v3.36c1.65-2.89,4.65-4.08,7.44-4.08,6.15,0,9.09,4.44,9.09,9.97v15.91h-5.99v-14.87c0-3.1-1.39-5.58-5.17-5.58-3.41,0-5.22,2.63-5.22,5.94v14.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.38,41.38h-5.99l-10.23-25.15h6.61l6.66,17.97,6.51-17.97h6.3l-9.86,25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.37,42.05c-7.39,0-12.14-5.84-12.14-13.38s4.8-13.17,12.03-13.17c4.44,0,6.71,2.32,7.39,4.03v-3.31h5.84v20.56c0,2.07.21,4.08.26,4.6h-5.73c-.1-.57-.26-1.91-.26-3.62-1.14,2.43-3.77,4.29-7.39,4.29ZM208.04,36.89c3.93,0,6.66-3.36,6.66-8.21s-2.69-7.95-6.66-7.95-6.82,3.1-6.82,7.95,2.63,8.21,6.82,8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.85,33.12c.21,2.27,1.91,4.29,5.11,4.29,2.48,0,3.77-1.34,3.77-2.89,0-1.34-.93-2.38-2.94-2.79l-3.72-.83c-4.44-.98-6.77-3.87-6.77-7.33,0-4.39,4.03-8.11,9.24-8.11,7.02,0,9.3,4.55,9.71,7.02l-5.06,1.45c-.21-1.45-1.29-3.77-4.65-3.77-2.12,0-3.62,1.34-3.62,2.89,0,1.34.98,2.32,2.53,2.63l3.82.78c4.75,1.03,7.23,3.93,7.23,7.64s-3.1,8.06-9.5,8.06c-7.28,0-10.07-4.75-10.38-7.59l5.22-1.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvas);
export default __webpack_public_path__ + "static/media/canvas.227a76565881f095172b863005bad335.svg";
export { ForwardRef as ReactComponent };